import ModeButton from 'components/Buttons/ModeButton';
import { useState } from 'react';

const TextToggle = ({
  options = ['1', '2'],
  value,
  setValue,
  activeStyle,
  inactiveStyle,
  buttonClassName = '',
  wrapperClassName = '',
  parentControlledState = false,
  disabled = false,
  enabled,
  ...rest
}) => {
  // Only use internal state if not parent controlled
  const [internalValue, setInternalValue] = useState(value);

  const handleChange = (val) => {
    if (!parentControlledState) setInternalValue(val === options[1]);
    setValue(val === options[1]);
  };

  // If parentControlledState, always use value prop; otherwise, use internal state (original behavior)
  const selected = parentControlledState
    ? value
      ? options[1]
      : options[0]
    : internalValue
      ? options[1]
      : options[0];

  return (
    <ModeButton
      options={options}
      onChange={handleChange}
      selectedOption={selected}
      activeStyle={activeStyle}
      inactiveStyle={inactiveStyle}
      buttonClassName={buttonClassName}
      wrapperClassName={wrapperClassName}
      parentControlledState={parentControlledState || false}
      enabled={enabled ?? !disabled}
      {...rest}
    />
  );
};

export default TextToggle;
